import $ from "jquery";
import * as validation from "./validation";
import axios from "axios";
import "url-search-params-polyfill";
import "promise-polyfill/src/polyfill";


export default class Form {
  constructor() {}

  init() {
    $("#js-form").submit((e) => {
      e.preventDefault();
      const errors = this.validation();

      if (errors.length > 0) {
        this.showErrors(errors);
      } else {
        if (window.confirm("ご入力の内容で送信してよろしいですか？")) {
          this.submit();
        }
      }
      // this.submit();
    });
  }

  submit() {
    console.log("[submit]");

    const name = $("#js-form [name=name]").val();
    const email = $("#js-form [name=email]").val();
    const tel = $("#js-form [name=tel]").val();
    const question = $("#js-form [name=question]").val();
    const license = $("#js-form [name=license]:checked").val();

    console.log(name);
    console.log(email);
    console.log(tel);
    console.log(question);
    console.log(license);

    const params = new URLSearchParams();
    params.append("name", name);
    params.append("email", email);
    params.append("tel", tel);
    params.append("question", question);
    params.append("license", license);

    axios.post("/php/entry.php", params, {
      headers: {"Content-Type": "application/x-www-form-urlencoded"}
    })
    .then(response => {
      console.log(response);
      alert("送信が完了しました。");
    }).catch(error => {
      console.log(error);
      alert(`ERROR\n${error}`);
    });
  }

  showErrors(errors) {
    let messages = "エラー\n";

    errors.forEach((error) => {
      messages = `${messages}\n${error}`;
    });

    alert(messages);
  }

  validation() {
    const errors = [];
    const name = $("#js-form [name=name]").val();
    const email = $("#js-form [name=email]").val();
    const tel = $("#js-form [name=tel]").val();
    const question = $("#js-form [name=question]").val();
    const check = $("#js-form [name=check]").is(":checked");

    if (validation.isBlank(name)) {
      errors.push("お名前を入力してください");
    }

    if (validation.isBlank(email)) {
      errors.push("メールアドレスを入力してください");
    } else if (!validation.isEemail(email)) {
      errors.push("メールアドレスが正しくありません");
    }

    if (validation.isBlank(tel)) {
      errors.push("電話番号を入力してください");
    }

    if (question) {
      if (question.length > 1000) {
        errors.push("ご質問は1000文字以内で入力してください");
      }
    }

    if (!check) {
      errors.push("個人情報方ご方針に同意にチェックを入れてください");
    }

    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Form.js